import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Input } from "@shadcn-in-nx/ui/input";
import { ChevronLeft, Upload } from "lucide-react";
import Message from "./Message";

function CreateWorkspaceStep1({
    name, setName, logoPreview, onLogoChange, error, apiError, setError, onContinue, onBack,
}) {
    const { t } = useTranslation();
    const fileRef = useRef(null);

    const handleFileSelect = (e) => {
        const file = e.target.files?.[0];
        if (file) onLogoChange(file);
    };

    return (
        <div className="flex-1 flex flex-col p-8 sm:p-12">
            <button onClick={onBack} className="flex items-center text-gray-400 hover:text-gray-600 mb-8 self-start">
                <ChevronLeft size={20} />
            </button>
            <h1 className="text-2xl font-semibold text-gray-900 mb-8">
                {t("sidebar.workspace.step1Title")}
            </h1>
            <div className="flex items-center gap-4 mb-8">
                <button
                    type="button"
                    onClick={() => fileRef.current?.click()}
                    className="w-14 h-14 rounded-full bg-gray-100 border-2 border-dashed border-gray-300 flex items-center justify-center hover:border-gray-400 transition-colors overflow-hidden shrink-0"
                >
                    {logoPreview ? (
                        <img src={logoPreview} alt="" className="w-full h-full object-cover" />
                    ) : (
                        <Upload size={20} className="text-gray-400" />
                    )}
                </button>
                <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/gif" className="hidden" onChange={handleFileSelect} />
                <div>
                    <p className="text-sm font-medium text-gray-900">{t("sidebar.workspace.logoTitle")}</p>
                    <p className="text-xs text-gray-500">{t("sidebar.workspace.logoHint")}</p>
                </div>
            </div>
            <div className="space-y-2 mb-auto">
                <label className="text-sm text-gray-600">{t("sidebar.workspace.nameLabel")}</label>
                <Input
                    placeholder={t("sidebar.workspace.namePlaceholder")}
                    value={name}
                    onChange={(e) => { setName(e.target.value); if (error) setError(""); }}
                    maxLength={100}
                    className="h-11"
                />
                {error && <p className="text-red-500 text-sm">{error}</p>}
                {apiError && <Message error>{apiError?.message}</Message>}
            </div>
            <button
                onClick={onContinue}
                className="w-full mt-8 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition-colors"
            >
                {t("sidebar.workspace.continue")}
            </button>
        </div>
    );
}

export default CreateWorkspaceStep1;
